module.exports = __webpack_public_path__ + "static/media/check-icon-white.71b7b139.svg";